// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34441187","337":"1f6908f2","351":"ef141a43","578":"28dabbc6","667":"d7d8231b","956":"9d63002f"}[chunkId] + ".chunk.js";
};